import { useReferentialNotifications } from "@/entities/referential/referential-notifications";
import { useGetSettingsNotifications } from "@/entities/settings";
import { AppLoading } from "@/ui/app-loading";

import { UserPreferencesNotifications } from "./user-preferences-notifications.component";

export const UserPreferencesNotificationsWrapper = () => {
  const {
    isLoading: isLoadingReferential,
    genericNotifications,
    moduleNotifications,
  } = useReferentialNotifications();
  const { isLoading: isLoadingSettings, userPreferencesNotifications } =
    useGetSettingsNotifications();

  if (isLoadingReferential || isLoadingSettings) {
    return <AppLoading />;
  }

  return (
    <UserPreferencesNotifications
      genericNotifications={genericNotifications}
      moduleNotifications={moduleNotifications}
      userPreferencesNotifications={userPreferencesNotifications}
    />
  );
};
